import { connectedStore } from '../../store/index';
import selectors from '../selectors/index';

const isHistoryEmpty = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const history = selectors.getHistory(state);

  return history.undo.length === 0 && history.redo.length === 0;
};

export default isHistoryEmpty;
